<!--平台伙伴-->
<template>
  <div>
    <el-row>
      <el-col :span="4"><div class="grid-content"></div></el-col>
      <!--面包屑-->
      <el-col :span="16">
        <div class="grid-content">
          <el-breadcrumb class='crumbs' separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item>
            <el-breadcrumb-item>活动列表</el-breadcrumb-item>
            <el-breadcrumb-item>活动详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
      <el-col :span="16">
        <!-- tabs选项卡-->
        <div class="grid-content1">
          <el-tabs :tab-position="tabPosition">
            <el-tab-pane label="中国矿物岩石地球化学学会大数据专委会">
              <el-tabs type="border-card">
                <el-tab-pane label="简介">
                  <div class='text'>
                    <p style='text-indent: 2em;'>
                      中国矿物岩石地球化学学会是中国科协的成员之一。其宗旨是：认真执行党和国家的方针、政策，贯彻“百花齐放，百家争鸣”方针，开展学术上的自由讨论；提倡辩证唯物主义和历史唯物主义，坚持实事求是的科学态度和优良学风；弘扬“尊重知识，尊重人才”的科学态度，积极倡导“献身、创新、求实、协作”精神；高举爱国主义旗帜，维护民族团结，促进祖国统一。坚持科学技术是第一生产力的思想，实施“科教兴国”和“可持续发展”战略；加强我国矿物岩石地球化学界的团结和国际合作，提倡和推广现代科学新理论、新技术在矿物学、岩石学和地球化学研究中的应用；组织学术交流，推动科学研究，提高科技人员的业务水平，开拓新的研究领域，发展边缘学科，促进出成果出人才；充分发挥学会在学科发展中的组织、协调和导向作用；积极普及科学知识，崇尚科学精神，提倡和推广科学方法；促进学科的繁荣和发展，为国民经济建设和科学技术现代化服务。
                    </p>
                    <p style='text-indent: 2em;'>
                      学会成立于1978年10月，目前有会员七千余名，其中终身会员1013人；下设24个专业委员会、3个工作委员会，每年开展学术活动和科普活动十余次。1981年代表中国加入国际矿物协会（IMA）和国际宇宙化学和地球化学协会（IAGC），目前是IMA的国家会员。
                    </p>
                    <h2 style='text-indent: 2em'>大数据与数学地球科学专业委员会</h2>
                    <h2>主任委员：</h2>
                    <p>周永章 中山大学地球环境与地球资源研究中心</p>
                    <h2>副主任委员：</h2>
                    <p>毛先成 中南大学    成秋明 中国地质大学(北京)    肖克炎 中国地质科学院矿产资源研究所    陈建平 中国地质大学(北京)</p>
                    <p>陈建国 中国地质大学(武汉)    周可法 中国科学院新疆生态与地理研究所    屈红刚 中国地质调查局发展研究中心</p>
                    <h2>委   员：（以姓氏汉语拼音为序）：</h2>
                    <p>陈郑辉 中国地质科学院矿产资源研究所    郭科 成都理工大学    郭艳军 北京大学    韩露 北京理工大学    何珍文 中国地质大学(武汉)</p>
                    <p>贺辉 北京师范大学    侯卫生 中山大学    李晓晖 合肥工业大学    梁元 成都理工大学    刘刚 中国地质大学(武汉)    刘玉葆 中山大学</p>
                    <p>卢宇彤 中山大学    路来君 吉林大学    罗熊 北京科技大学    汤军 长江大学    王树功 中山大学    王文磊 中国地质科学院地质力学研究所    王永志 吉林大学</p>
                    <p>王占刚 中国矿业大学（北京）    吴志峰 广州大学    夏庆霖 中国地质大学资源学院(武汉)    肖侬 中山大学    杨永国 中国矿业大学  余先川 北京师范大学</p>
                    <p>左仁广 中国地质大学(武汉) </p>
                    <h2>秘   书：</h2>
                    <p>王树功 中山大学  朱月琴 中国地质调查局发展研究中心 </p>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="会议">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="挑战赛">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="资讯">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知123456666</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="数字地球国家委员会大数据专委会">
              <el-tabs type="border-card">
                <el-tab-pane label="简介">
                  <div class='text'>
                    <p style='text-indent: 2em;'>
                      国际数字地球学会中国国家委员会（Chinese National Committee of ISDE，简称CNISDE）是在我国设立的数字地球领域的学术组织，并代表中国加入国际数字地球学会。
                    </p>
                    <p style='text-indent: 2em;'>
                      CNISDE于2006年5月正式成立，由相关部委、科研部门、高校、企业等单位从事数字地球理论、技术研究，应用、开发，教学、管理工作的六十余位专家学者组成。
                    </p>
                    <p style='text-indent: 2em;'>
                      CNISDE的宗旨是以服务国家经济社会发展为中心，团结科技工作者，组织开展国内外学术交流研讨，致力于数字地球领域的基础理论、技术和应用发展。秘书处设在中国科学院遥感与数字地球研究所。
                    </p>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="会议">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="资讯">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知123456666</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="IAMG-SYSU">
              <el-tabs type="border-card">
                <el-tab-pane label="Introduction">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="Activities">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="Courses">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="Information">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="广东地质过程与矿产资源探查重点实验室">
              <el-tabs type="border-card">
                <el-tab-pane label="简介">
                  <div class='text'>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      广东省地质过程与矿产资源探查重点实验室是广东省科技厅批准立项建设的重点研究基地。它主要依托中山大学地球科学系地质学科，并整合校内相关力量而建成。现任实验室主任是周永章教授，实验室学术委员会主任是翟明国院士。
                    </p>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      重点实验室最早可以追溯到上世纪20年代由国民革命政府批准成立的两广地质调查所。该所依托中山大学地质学科，从一开始就肩负着从科学技术上支撑孙中山先生建设经济强国梦想《治国方略》的重任，开创了中国人于两广地区地质调查先河，首版两广地区地质图、矿产图，是当时国内4个最有影响力的地质调查所之一。1926年，黄著勋教授著《中国矿产》，并由商务印书馆出版，是中国最早的矿物学、岩石学、矿床学著著之一。朱家骅、谢家荣、孙云铸、乐森璕、斯行健、冯景兰、杨遵仪、陈国达等院士都曾在该所担当教研任务。
                    </p>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      重点实验室紧扣矿产资源的探查增储和绿色矿业开发两大主题，立足能源金属矿床、有色金属贵金属矿床及绿色矿业技术重点方向，以矿产资源形成的重大地质事件-关键地质过程、成矿系统的时空结构、资源环境效应及探查评价的理论和技术为主要内容，致力于广东优势矿产资源和战略矿产资源的探查增储和绿色矿业发展，提高广东实现可持续发展的矿产资源和能源保障能力。
                    </p>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      重点实验室以实验平台建设为基础，主要通过承担重要科研任务和培养人才来推动实验室发展。实验室实行“开放、流动、竞争、协作”的运行机制。在重点实验室下的各研究团队实行“教授（PI）管理，科学问题引导，研究团队配合，技术员支持，博士、硕士研究生积极参与”的运行模式。实验室努力发挥广州地学单位集中的优势，加强与兄弟单位的合作，加强产学研合作，加强国际学术交流。实验室围绕特定时期的重点方向设立开放基金课题和访问学者各位，热忱欢迎相关专业科技人员申报。
                    </p>
                    <p>
                      重点实验室学术委员会主任：翟明国 <br> 重点实验室主任：周永章；副主任：杨志军、张澄博
                    </p>
                    <h2>
                      办公室地址和联系方式
                    </h2>
                    <p>
                      广州新港西路135号中山大学地环大楼C座2楼 <br>
                      广东省地质过程与矿产资源探查重点实验室 <br>
                      电  话：020-84111255 <br>
                      联系人：杨威 <br>
                    </p>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="会议">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="资讯">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知123456666</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="广东高质大数据科技有限公司">
              <el-tabs type="border-card">
                <el-tab-pane label="简介">
                  <div class='text'>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      公司利用大数据、云计算、物联网及人工智能技术，通过技术和产品创新，设计出了基于图数据库技术的全息数据库和基于区块链技术的超级账本，打造了智能能源互联网平台、智能医疗物联网平台、智能电子政务平台等软件系统平台，同时研发出GloStor云存储、 GloProc云处理、 GloVideo云视频、 GloTrans云传输、GloMiner大数据挖掘等软硬件系统产品。
                    </p>
                    <p style='text-indent: 2em'>
                      公司拥有优秀的管理团队和技术团队，核心技术团队由多名国内知名云计算、大数据、人工智能领域的专家组成，企业拥有自主知识产权的核心专利技术和产品，致力于为客户提供全系统的“大数据+人工智能解决方案” ，有效提升客户的数据资产利用价值和智能化管理水平。
                    </p>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="业务产品">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="资讯">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知123456666</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="广东低碳技术创新应用工程技术研究中心">
              <el-tabs type="border-card">
                <el-tab-pane label="简介">
                  <div class='text'>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      广东省低碳技术创新应用工程技术研究中心是广东省科学技术厅批准立项建设的省级工程研究中心，由广东埃文低碳科技股份有限公司（股票代码：871556）、中山大学与广东省低碳产业技术协会联合建设。中心主要围绕节能减碳与新能源技术创新应用、碳（排放权）-环境-能源交易一体化服务系统与大数据技术融合、碳标识-碳中和产品开发，以及绿色区块链技术开发与应用等领域开展应用研究，以推进低碳技术产业化及技术创新应用，致力于打造绿色低碳技术创新平台、绿色低碳技术成果转化中心、绿色低碳技术产业孵化基地，为依托单位提供技术支撑，提升行业技术创新应用与转化能力。
                    </p>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      粤港澳大湾区建设国际创新中心为该中心的建设提供了难得的历史机遇，中心将抓住机遇，以建成国家级技术创新中心为目标，建设世界一流低碳技术创新应用中心，为经济社会发展提供低碳转型新动能，为低碳产业新生态建设做出应有的贡献。
                    </p>
                    <p style='text-indent: 2em'>
                      该中心建设主要依托单位广东埃文低碳科技股份有限公司，是一家极具专业技术背景的应对气候变化和企业节能减排低碳发展综合解决方案提供商、新三板挂牌公众公司，致力于通过各种创新实践推动中国低碳发展，是全国细分行业隐形冠军和极具独角兽潜质的企业。
                    </p>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="业务产品">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="资讯">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知123456666</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="广东大数据与绿色供给技术工程研究中心">
              <el-tabs type="border-card">
                <el-tab-pane label="简介">
                  <div class='text'>
                    <p style='text-indent: 2em'>
                      广东省大数据与绿色供应技术工程技术研究中心致力于大数据、大数据算法与绿色生态供给技术嫁接，实现科技成果落地转化，主要研究方向包括智能城市建设生态惠民大数据服务技术、基于大数据的生态资源与环境质量智能化监测、预测预警及管控系统技术、区域开发环境效应评价大数据技术和绿色产品溯源区块链关键技术。
                    </p>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="业务产品">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="资讯">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知123456666</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="广州城市可持续发展研究会">
              <el-tabs type="border-card">
                <el-tab-pane label="简介">
                  <div class='text'>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      广州城市可持续发展研究会致力于联系广州地区从事城市可持续发展的专家、学者，以及对城市可持续发展感兴趣的政府、新闻等各界人士，在可持续发展理念的指引下，开展城市可持续发展以及城市规划、建设、管理、经营系统的研究和交流。
                    </p>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      现阶段主要工作包括：（1）组织有关专家、学者开展城市可持续理论以及可持续发展框架下城市规划、建设、管理、经营系统的研究；（2）承担政府和社会各界委托的城市可持续发展和城市规划、建设、管理、经营方面的咨询业务；（3）通过研讨会、讲座、培训等形式，推动城市可持续发展研究，宣传城市可持续发展观念；（4）开展中外学术交流与合作。
                    </p>
                    <p style='text-indent: 2em;margin-bottom: 5px'>
                      研究会目前分布在珠江三角洲地区主要高校和社会科学、自然科学研究机构，以及多个行业企业和政府相关部门。
                    </p>
                    <p style='text-indent: 2em'>
                      研究会理事长: 周永章
                    </p>
                    <p style='text-indent: 2em'>
                      秘书长: 刘光华
                    </p>
                    <p style='text-indent: 2em'>
                      研究会秘书处办公室地址：广州市番禺区番禺大道北555号天安科技园总部中心5号楼2楼
                    </p>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="会议">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="资讯">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知123456666</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="绿色供应链互联网解释二级节点">
              <el-tabs type="border-card">
                <el-tab-pane label="简介">
                  <div class='text'>
                    <p style='text-indent: 2em'>
                      绿色供应链标识解析二级节点以为绿色供应链各类主体提供标识编码注册和标识解析服务为基础，实现绿色产品全生命周期可追溯及绿色资源信息共享。它以云上的集成式解决方案让绿色供应链实现全面实时互联，从根本上改善目前绿色供应链难管理、难追溯、难监控的问题，是智能化提升供应链的绿色化水平最直接、最有效的方式。
                    </p>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="产品">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="资讯">
                  <ul>
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>第四届全国大数据与数学地球科学学术研讨会通知（一号）暨第二届中国地球科学大数据挖掘与人工智能挑战赛通知123456666</a>
                        </li>
                        <li class='date'>
                          <span>2022.03.27</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination
                    class='pagination'
                    small
                    layout="prev, pager, next"
                    :total="50">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="广州碳排放权交易所" >
               <a href='https://www.cnemission.com/'> </a>
            </el-tab-pane>
            <el-tab-pane label="北京碳排放权交易所" >
              <a href='http://www.tanpaifang.com/'> </a>
            </el-tab-pane>
            <el-tab-pane label="兰州环境产权交易所" >
              <a href='http://abc.gscq.com.cn/'> </a>
            </el-tab-pane>
            <el-tab-pane label="广东埃文低碳股份有限公司" >
              <a href='http://www.avicanton.org/'> </a>
            </el-tab-pane>
            <el-tab-pane label="易碳家" >
              <a href='http://www.yitanjia.com/'> </a>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fits: ['cover'],
      tabPosition: 'left'
    }
  }
}
</script>

<style lang="less" scoped>
.el-row {
  padding-bottom: 20px;
  background-color: #eee;
  &:last-child {
    margin-bottom: 0;
  }
}
.grid-content {
  height: 50px;
  //面包屑
  .crumbs{
    line-height:50px;
    font-size: 16px;
    text-indent: 10px;
    background-color: #fff;
    margin-top: 20px;
  }
}
::v-deep .el-tabs__content{
  padding-bottom: 20px;
  background-color: #fff;
}
.grid-content1 {
  min-height: 100px;
  //文本内容
  .text{
    p{
      line-height: 28px;
      font-size: 14px;
      font-family: "MicrosoftYaHei";
    }
    h2{
      line-height: 28px;
      font-size: 15px;
      font-family: "MicrosoftYaHei";
      font-weight: bold;
      color: #666;
    }
  }
  .content{
    height: 50px;
    padding: 0 15px;
    background-color: #fff;
    border-bottom: 1px dashed #999;
    line-height: 50px;
    .icon{
      width:2.5%;
      float: left;
    }
    .title{
      width:85%;
      float: left;
      a{
        width: 100%;
        display: block;
        color: #666;
        font-family: "MicrosoftYaHei";
        overflow: hidden;        /*内容会被修剪，并且其余内容是不可见的*/
        text-overflow:ellipsis;  /*显示省略符号来代表被修剪的文本。*/
        white-space: nowrap;     /*文本不换行*/
      }
      a:hover{
        color:#409EFF ;
      }
    }
    .date{
      width:12.5%;
      float: right;
      text-align: right;
    }
  }
  .paging{
    width: 100%;
    height: 80px;
    background-color: #fff;
    .pagination{
      float: right;
      margin-top: 20px;
    }
  }
}
//分页
.pagination{
  margin-top: 15px;
  float: right;
}
//tabs选项卡
::v-deep .el-tabs{
  background-color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left{
  text-align: center;
  height:46px;
  width: 300px;
  font-family: Tahoma;
  font-size: 14px;
  color: #333;
}
::v-deep .el-tabs__nav-scroll{
  background-color: #fff !important;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:hover{
  background-color: #11a84e;
  color: #fff;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:nth-child(1) :hover{
  color: #409EFF;
}
::v-deep .el-tabs--left .el-tabs__item.is-left:focus{
  background-color: #11a84e;
  color: #fff;
}
::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item{
  font-size: 16px;
  font-weight: bold;
  font-family: "MicrosoftYaHei";
  width: 245px;
  color: #666;
  text-align: center;
  border: 0;
}
::v-deep .el-tabs--left .el-tabs__header.is-left{
  margin: 0;
}
// 默认选中的样式
::v-deep .el-tabs--left .el-tabs__item.is-active{
  background-color:#11a84e;
  color: #fff;
}
::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  background-color: #fff;
  color: #409EFF;
}
</style>
